import React, { useEffect, useState } from "react";
import { FieldsBox, Field } from "@onefront/react-workspace-components";
import { useTranslation } from "@onefront/react-sdk";
import { BusinessFooterForm } from "../footer";
import { Box, Divider, Stack } from "@vapor/react-material";
import { proRataRows } from "./rows";
import { BoxSkeleton } from "../../../../features/business/components/skeletons/boxskeleton";

export const BusinessIvaProRataForm = ({
    items,
    setItems,
    businessId,
    pastIvaProRata,
    bodyRequest,
    handleChange,
    onForward,
    onBack,
    itemToSave,
    setItemToSave,
    onDelete,
    isEditing,
    isEditingItem,
    setIsEditingItem,
    loading,
    isNewBusiness
}) => {
    const { t } = useTranslation();
    const dateYear = new Date().getFullYear();

    const [itemsSettings, setItemsSettings] = useState({});
    const [pastIvaProRataSettings, setPastIvaProRataSettings] = useState({});

    useEffect(() => {
        let settings = {};

        items?.map(item => {
            settings[item.id] = {
                title: (
                    <Box sx={{ marginBottom: 2 }}>
                        {t("general.year")} {item?.proRataYear}
                    </Box>
                ),
                notCancellable: !isEditing,
                notEditable: !isEditing
            };
            return null;
        });

        setItemsSettings(settings);
    }, [items, isEditing, businessId, t]);

    useEffect(() => {
        if (pastIvaProRata?.length === 0) return;

        let settingsPastIvaProRata = {};
        pastIvaProRata?.map(item => {
            settingsPastIvaProRata[item.id] = {
                title: (
                    <Box sx={{ marginBottom: 2 }}>
                        {t("general.year")} {item?.proRataYear}
                    </Box>
                ),
                notCancellable: true,
                notEditable: true
            };
            return null;
        });

        setPastIvaProRataSettings(s => ({ ...s, ...settingsPastIvaProRata }));
    }, [pastIvaProRata, setPastIvaProRataSettings, t]);

    return (
        <Stack spacing={2}>
            <Field
                component="radio"
                label={t("business.fields.ivaProRataHandled")}
                isEditing={isEditing}
                fullWidth
                onChange={val => {
                    handleChange(val === "true" ? true : false, "ivaProRataHandled");
                    setIsEditingItem(dateYear);
                    const ivaProRataOfYear = items?.find(item => item?.proRataYear === dateYear);
                    setItemToSave({
                        id: dateYear,
                        idIvaProRata: ivaProRataOfYear?.idIvaProRata || null,
                        proRataManagementType: "NON_DEDUCTIBLE_VAT_ON_COSTS",
                        proRataYear: dateYear,
                        proRataNonDeducibilityRate: "100"
                    });
                }}
                value={bodyRequest?.ivaProRataHandled}
                radioGroupAlign="vertical"
                options={[
                    {
                        id: true,
                        value: t("general.yes")
                    },
                    {
                        id: false,
                        value: t("general.no")
                    }
                ]}
                loading={loading}
            />

            {bodyRequest?.ivaProRataHandled && !loading && (
                <FieldsBox
                    disableAdd
                    items={items}
                    itemsSettings={itemsSettings}
                    isEditing={isEditingItem}
                    editedItem={isEditing ? itemToSave : null}
                    enableSave={itemToSave?.proRataNonDeducibilityRate}
                    name={t("general.year")}
                    onCancel={() => {
                        const newItems = items?.filter(item => item?.proRataYear !== itemToSave?.proRataYear);
                        itemToSave.proRataNonDeducibilityRate = `${itemToSave.proRataNonDeducibilityRate}%`;
                        setItems([...newItems, itemToSave]);
                        setIsEditingItem(null);
                    }}
                    onAdd={() => {}}
                    onDelete={() => {
                        handleChange(false, "ivaProRataHandled");
                        onDelete();
                    }}
                    onEdit={(itemId, item) => {
                        item.proRataNonDeducibilityRate = item?.proRataNonDeducibilityRate?.replace("%", "");
                        setIsEditingItem(itemId);
                        setItemToSave(item);
                    }}
                    onSave={() => {
                        const newItems = items?.filter(item => item?.proRataYear !== itemToSave?.proRataYear);
                        itemToSave.proRataNonDeducibilityRate = `${itemToSave.proRataNonDeducibilityRate}%`;
                        setItems([...newItems, itemToSave]);
                        setIsEditingItem(null);
                        setItemToSave({});
                    }}
                    onValueChange={(name, value) => {
                        setItemToSave({ ...itemToSave, [name]: value });
                        if (name === "proRataManagementType" && value === "NON_DEDUCTIBLE_VAT_ON_COSTS") {
                            setItemToSave({ ...itemToSave, [name]: value, proRataNonDeducibilityRate: "100" });
                        } else {
                            setItemToSave({ ...itemToSave, [name]: value });
                        }
                    }}
                    rows={proRataRows(t, itemToSave, isEditingItem) as any}
                />
            )}

            {loading && bodyRequest?.ivaProRataHandled && <BoxSkeleton n={1} />}

            {isEditing && (
                <BusinessFooterForm
                    isNewBusiness={isNewBusiness}
                    onBack={onBack}
                    onForward={onForward}
                    loading={loading}
                    disabledForward={loading || (bodyRequest?.ivaProRataHandled && isEditingItem)}
                    lastStep
                />
            )}

            {pastIvaProRata?.length > 0 && !loading && (
                <Stack>
                    <Divider variant={"fullWidth"} light sx={{ my: 3 }} />
                    <Stack mt={2}>
                        <FieldsBox
                            disableAdd
                            items={pastIvaProRata}
                            itemsSettings={pastIvaProRataSettings}
                            isEditing={false}
                            name={t("general.year")}
                            rows={proRataRows(t, itemToSave, isEditing) as any}
                            enableSave={false}
                            onAdd={() => {}}
                            onDelete={() => {}}
                            onEdit={() => {}}
                            onCancel={() => {}}
                            onSave={() => {}}
                            onValueChange={() => {}}
                        />
                    </Stack>
                </Stack>
            )}
        </Stack>
    );
};
